import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';
import ObjectTemplateHeadersEditor from '../common/inputs/objectTemplateHeadersEditor';
import ObjectTemplateMetricsDetailEditor from '../common/inputs/objectTemplateMetricsDetailEditor';
import ErrorFeedback from '../common/feedback/errorFeedback';
import FormulaEditorLink from '../common/inputs/formulaEditorLink';
import LocaleTooling from '../../../tooling/localeTooling';
import RichTextInput from '../common/inputs/richTextInput';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusPreloading,
    loadingPreloading,
    pendingSaveFields,
    statusButton,
    modelsData,
    tablesData,
    formData,
    errors,
    entityNameSingular,
    handleEditFormulaLink,
    handleEditMetricDetailColumnsLink,
    handleSaveUserImage,
    handleCloneDetail,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={loadingPreloading ? "common.entity.loadingEntity" : (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.id") ? "common.entity.editEntity" : "common.entity.createEntity")}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={loadingPreloading ? "common.entity.loadingEntity" : (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.id") ? "common.entity.editEntity" : "common.entity.createEntity")}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
      handleButton={(statusPreloading==200 || formData.isEmpty) ? handleButton : null}
    >
      {(statusPreloading==200 || formData.isEmpty) && (
        <div>
          <ErrorFeedback
            status={statusButton}
            fieldErrors={errors}
            localesFieldsPath="reportTemplateAdmin.fields"
            optionalStatusErrors={{
              "406": intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
                 {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "reportTemplateAdmin.entityNameSingularWithArticle"})), 
                  detail: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "reportTemplateAdmin.blockedDeleteDeactivateDetail"}))})
            }}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="name"
            data-path="report_template.name"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.name")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.name"/>}
            className={("name" in errors) ? "has_error" : null}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="title"
            data-path="report_template.title"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.title")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.title"/>}
            className={("title" in errors) ? "has_error" : null}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="subtitle"
            data-path="report_template.subtitle"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.subtitle")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.subtitle"/>}
            className={("subtitle" in errors) ? "has_error" : null}
          />                     
          <RichTextInput 
            onChange={handleOnChangeForm}
            data-path="report_template.rich_description"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.rich_description")}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.rich_description"/>}
            handleSaveUserImage={handleSaveUserImage}
          />
          <CheckBox 
            id="new_page_after_rich_description"
            data-path="report_template.new_page_after_rich_description"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.new_page_after_rich_description")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.new_page_after_rich_description"/>}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="footer"
            data-path="report_template.footer"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.footer")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.footer"/>}
            className={("footer" in errors) ? "has_error" : null}
          />
          <label className="form_info">
            {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id={"reportTemplateAdmin.filenameWarning"}/>)}
          </label>
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="filename"
            data-path="report_template.filename"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.filename")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.filename"/>}
            className={("filename" in errors) ? "has_error" : null}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="password"
            data-path="report_template.password"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.password")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.password"/>}
            className={("password" in errors) ? "has_error" : null}
          />
          <ObjectTemplateHeadersEditor 
            id="header"
            data-path="report_template.header"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.header")}
            onChange={handleOnChangeForm}
            className={("header" in errors) ? "has_error" : null}
          />
          <ObjectTemplateMetricsDetailEditor 
            id="metrics_detail"
            data-path="report_template.metrics_detail"
            modelsData={modelsData}
            tablesData={tablesData}
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.metrics_detail")}
            onChange={handleOnChangeForm}
            handleEditFormulaLink={handleEditFormulaLink}
            handleEditMetricDetailColumnsLink={handleEditMetricDetailColumnsLink}
            pendingSaveFields={pendingSaveFields}
            handleCloneDetail={handleCloneDetail}
            className={("metrics_detail" in errors) ? "has_error" : null}
          />
          <div className="row_fields">
            <CheckBox 
              id="hide_total"
              data-path="report_template.hide_total"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.hide_total")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.hide_total"/>}
            />
            <CheckBox 
              id="no_breadcrum"
              data-path="report_template.no_breadcrum"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.no_breadcrum")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.no_breadcrum"/>}
            />
            {false && (<CheckBox 
              id="show_deep_tree"
              data-path="report_template.show_deep_tree"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.show_deep_tree")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.show_deep_tree"/>}
            />)}     
          </div>
          {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.hide_total")==false) && (
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.TEXT}
              id="total_string"
              data-path="report_template.total_string"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.total_string")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.total_string"/>}
              className={("total_string" in errors) ? "has_error" : null}
            />
          )}
          <ToggleSection
            title={<FormattedMessage id="reportTemplateAdmin.fields.formatTitle"/>}
          >
            <div>
              <div className="row_fields">
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  maxlength={1}
                  type={Constants.interface.inputs.type.TEXT}
                  id="thousands_separator"
                  data-path="report_template.thousands_separator"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.thousands_separator")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.thousands_separator"/>}
                  className={("thousands_separator" in errors) ? "has_error" : null}
                />
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  maxlength={1}
                  type={Constants.interface.inputs.type.TEXT}
                  id="decimal_separator"
                  data-path="report_template.decimal_separator"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.decimal_separator")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.decimal_separator"/>}
                  className={("decimal_separator" in errors) ? "has_error" : null}
                />
              </div>
              <div className="row_fields">
                <Select 
                  id="format_type"
                  data-path="report_template.format_type"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.format_type")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.format_type"/>}
                  options={InterfaceTooling.getSelectArray("selectKeys.reportTemplate.format","reportTemplateAdmin.fields.selectValues.format")}
                  className={("format_type" in errors) ? "has_error" : null}
                />
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                  type={Constants.interface.inputs.type.TEXT}
                  id="decimals"
                  data-path="report_template.decimals"
                  value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.decimals")}
                  onChange={handleOnChangeForm}
                  labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.decimals"/>}
                  className={("decimals" in errors) ? "has_error" : null}
                />
              </div>
            </div>
          </ToggleSection>
          <ToggleSection
            title={<FormattedMessage id="reportTemplateAdmin.fields.emailDetailsTitle"/>}
          >
            <div>
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="email_from"
                data-path="report_template.email_from"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.email_from")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.email_from"/>}
                className={("email_from" in errors) ? "has_error" : null}
              />
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="email_to"
                data-path="report_template.email_to"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.email_to")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.email_to"/>}
                className={("email_to" in errors) ? "has_error" : null}
              />
              <label className="form_info email_helper">
                {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="reportTemplateAdmin.emailToHelp"/>)}
              </label>
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="email_cc"
                data-path="report_template.email_cc"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.email_cc")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.email_cc"/>}
                className={("email_cc" in errors) ? "has_error" : null}
              />
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="email_subject"
                data-path="report_template.email_subject"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.email_subject")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.email_subject"/>}
                className={("email_subject" in errors) ? "has_error" : null}
              />
              <TextBox 
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                id="email_body"
                data-path="report_template.email_body"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.email_body")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.email_body"/>}
                className={("email_body" in errors) ? "has_error" : null}
              />  
            </div>
          </ToggleSection>
          <div className="row_fields">
            <CheckBox 
              id="default"
              data-path="report_template.default"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.default")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="reportTemplateAdmin.fields.default"/>}
              className={("default" in errors) ? "has_error" : null}
            />
            {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.id") && (
              <CheckBox 
                id="active"
                data-path="report_template.active"
                value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"report_template.active")}
                onChange={handleOnChangeForm}
                labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
              />
            )}
          </div>
        </div>
      )}
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/reportTemplateAdmin/formPopup.jsx